import { action, computed, makeObservable, observable } from "mobx";
import dayjs from "dayjs";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import CumulativeBurnupSeries from "./CumulativeBurnupSeries";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

export default class RevenueBurnupFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._revenueBurnup = [];

        makeObservable(this, {
            _revenueBurnup: observable,
            revenueBurnup: computed,
            setRevenueBurnup: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getRevenueBurnup();
        this.finishLoading();
    }

    setRevenueBurnup(data) {
        this._revenueBurnup = data;
    }

    get revenueBurnup() {
        return this._revenueBurnup;
    }

    async _getRevenueBurnup() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setRevenueBurnup(this._adaptDailySalesProgress(response.dailySalesProgress()));
            },
            handlesError: () => {
                errorToast("No se pudo obtener la facturación acumulada");
                this.setRevenueBurnup([]);
            },
        });
        return this._application.apiClient().getDailySalesProgress(responseHandler, this._filters.fromDate,
                                                                   this._filters.toDate, this._filters.channels,
                                                                   this._filters.articleCategories,
                                                                   this._filters.withoutAllowances);
    }

    _adaptDailySalesProgress(dailySalesProgress) {
        const today = dayjs().startOf("day");
        const moneyPoints = CumulativeBurnupSeries.money().pointsFor(dailySalesProgress, today);
        const boxesPoints = CumulativeBurnupSeries.boxes().pointsFor(dailySalesProgress, today);

        return dailySalesProgress.map((dailyEntry, dayIndex) => ({
            day: dailyEntry.date.date(),
            label: dailyEntry.date.format("DD/MM"),
            invoiced: moneyPoints[dayIndex].invoiced,
            projected: moneyPoints[dayIndex].projected,
            target: moneyPoints[dayIndex].target,
            invoicedBoxes: boxesPoints[dayIndex].invoiced,
            projectedBoxes: boxesPoints[dayIndex].projected,
            targetBoxes: boxesPoints[dayIndex].target,
        }));
    }
}
